// extracted by css-extract-rspack-plugin
export default {"dot":"dot-k5SXzE","divider":"divider-E4GNVS","truncation":"truncation-P1FxRL"};